import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import useAuth from '../hooks/useAuth';
import { PATH_AUTH } from '../routes/paths';
import Iconify from './Iconify';

export default function AdminLogoutButton({ variant = 'outlined', color = 'inherit', size = 'medium' }) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { logout } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    try {
      setLoading(true);
      await logout();
      navigate(PATH_AUTH.login, { replace: true });
    } catch (error) {
      enqueueSnackbar('Unable to logout', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoadingButton
      loading={loading}
      onClick={handleLogout}
      variant={variant}
      color={color}
      size={size}
      startIcon={<Iconify icon="solar:logout-2-bold" />}
    >
      Logout
    </LoadingButton>
  );
}

AdminLogoutButton.propTypes = {
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
};
